/* eslint-disable react/no-multi-comp */
import { createIcon, Icon, IconProps } from "@chakra-ui/react";

import { CloudProviderEnum } from "@/__generated__/graphql";

export const BitbucketIcon = createIcon({
  displayName: "Bitbucket",
  viewBox: "5 5 22 22",
  path: [
    <path
      key={0}
      clipRule="evenodd"
      d="M5.49883 6.64561C5.63068 6.49266 5.82343 6.40584 6.02535 6.40844L25.974 6.41186C26.1759 6.40926 26.3687 6.49608 26.5005 6.64903C26.6324 6.80198 26.6898 7.00541 26.6575 7.20475L23.756 25.0174C23.7018 25.3517 23.411 25.5959 23.0724 25.5915H9.15247C8.70134 25.5878 8.31801 25.2607 8.24339 24.8157L5.34183 7.20133C5.3095 7.00199 5.36697 6.79856 5.49883 6.64561ZM13.8004 19.1391H18.2433L19.3199 12.8541H12.5974L13.8004 19.1391Z"
      fill="#2684FF"
      fillRule="evenodd"
    />,
    <path
      key={1}
      d="M25.7351 12.8541H19.3202L18.2436 19.1391H13.8007L8.55469 25.366C8.72096 25.5098 8.93296 25.5897 9.15277 25.5916H23.0762C23.4148 25.5959 23.7055 25.3517 23.7597 25.0174L25.7351 12.8541Z"
      fill="url(#paint0_linear_5831_35994)"
    />,
  ],
});

export const GoogleIcon = createIcon({
  displayName: "Google",
  viewBox: "5 5 22 22",
  path: [
    <path
      key={0}
      d="M16.2135 9.45779C18.2164 9.45779 19.5675 10.323 20.3379 11.0459L23.3483 8.10668C21.4994 6.38816 19.0935 5.33334 16.2135 5.33334C12.0416 5.33334 8.43864 7.72742 6.68457 11.2119L10.1335 13.8904C10.9986 11.3185 13.3927 9.45779 16.2135 9.45779V9.45779Z"
      fill="#EA4335"
    />,
    <path
      key={1}
      d="M26.4539 16.237C26.4539 15.36 26.3828 14.72 26.2287 14.0563H16.2139V18.0148H22.0924C21.9739 18.9985 21.3339 20.48 19.9116 21.4756L23.2776 24.083C25.2924 22.2222 26.4539 19.4845 26.4539 16.237V16.237Z"
      fill="#4285F4"
    />,
    <path
      key={2}
      d="M10.1454 18.1096C9.92021 17.4459 9.78984 16.7348 9.78984 16C9.78984 15.2652 9.92021 14.5541 10.1335 13.8904L6.68465 11.2119C5.96169 12.6578 5.54688 14.2815 5.54688 16C5.54688 17.7185 5.96169 19.3422 6.68465 20.7882L10.1454 18.1096V18.1096Z"
      fill="#FBBC05"
    />,
    <path
      key={3}
      d="M16.2133 26.6667C19.0933 26.6667 21.5111 25.7185 23.277 24.083L19.9111 21.4756C19.0104 22.1037 17.8015 22.5422 16.2133 22.5422C13.3926 22.5422 10.9985 20.6815 10.1452 18.1096L6.69629 20.7882C8.45036 24.2726 12.0415 26.6667 16.2133 26.6667V26.6667Z"
      fill="#34A853"
    />,
  ],
});

export const GcpIcon = createIcon({
  displayName: "Google Cloud Platform",
  viewBox: "0 0 333334 268125",
  path: [
    <path
      key={0}
      d="M212126 74104l10677 183 29010-29011 1406-12291C229395 11715 198568-27 166631 1 106527 1 55798 40897 40782 96293c3167-2209 9937-552 9937-552l57969-9531s2979-4932 4489-4687c13706-15059 33128-23638 53489-23630 17188 36 33021 6109 45459 16156v56h1z"
      fill="#ea4335"
    />,
    <path
      key={1}
      d="M292553 96355c-6735-24844-20615-46781-39349-63422l-41078 41078c16459 13281 27016 33604 27016 56354v7250c19984 0 36219 16271 36219 36219 0 19984-16271 36219-36219 36219h-72438l-7250 7292v43469l7250 7213h72438c51989-73 94115-42198 94193-94187-37-32057-16146-60417-40781-77479v-5z"
      fill="#4285f4"
    />,
    <path
      key={2}
      d="M94193 268125h72396v-58020H94193c-5144 1-10227-1104-14906-3240l-10453 3203-29010 29010-2541 9792c16348 12472 36343 19224 56906 19214l5 41z"
      fill="#34a853"
    />,
    <path
      key={3}
      d="M94193 79688C42204 79813 73 121938 0 173928c0 30589 14652 57787 37323 75016l41999-42000c-12984-5856-21337-18772-21349-33016 0-19984 16271-36219 36219-36219 14687 0 27313 8854 33021 21355l42000-42000c-17224-22672-44427-37323-75015-37323l-5-53z"
      fill="#fbbc05"
    />,
  ],
});

export const GitHubIcon = createIcon({
  displayName: "GitHub",
  viewBox: "3 3 26 26",
  path: [
    <path
      key={0}
      d="M16.0001 4C9.3735 4 4 9.50847 4 16.3038C4 21.74 7.43839 26.3519 12.2064 27.9789C12.8061 28.0927 13.0263 27.7119 13.0263 27.387C13.0263 27.0936 13.0152 26.1244 13.01 25.0963C9.67157 25.8405 8.96712 23.6446 8.96712 23.6446C8.42125 22.2224 7.63473 21.8443 7.63473 21.8443C6.54596 21.0806 7.7168 21.0963 7.7168 21.0963C8.92181 21.1831 9.55632 22.3642 9.55632 22.3642C10.6266 24.2452 12.3636 23.7014 13.0484 23.387C13.1561 22.5918 13.4671 22.049 13.8102 21.7418C11.1449 21.4307 8.34295 20.3757 8.34295 15.6612C8.34295 14.3179 8.81172 13.2203 9.57937 12.3587C9.45477 12.0488 9.04402 10.7974 9.69562 9.10261C9.69562 9.10261 10.7033 8.77193 12.9965 10.3638C13.9537 10.0912 14.9803 9.95447 16.0001 9.94979C17.0199 9.95447 18.0473 10.0912 19.0063 10.3638C21.2967 8.77193 22.303 9.10261 22.303 9.10261C22.9562 10.7974 22.5452 12.0488 22.4206 12.3587C23.1901 13.2203 23.6557 14.3179 23.6557 15.6612C23.6557 20.3869 20.8484 21.4274 18.1762 21.732C18.6067 22.1138 18.9902 22.8626 18.9902 24.0105C18.9902 25.6568 18.9763 26.9817 18.9763 27.387C18.9763 27.7144 19.1923 28.098 19.8006 27.9772C24.566 26.3485 28 21.7381 28 16.3038C28 9.50847 22.6273 4 16.0001 4"
      fill="#161514"
    />,
    <path
      key={1}
      d="M8.58055 21.5811C8.55417 21.6417 8.46055 21.6598 8.37526 21.6183C8.28838 21.5785 8.23959 21.496 8.26775 21.4353C8.29354 21.373 8.38736 21.3556 8.47403 21.3974C8.56111 21.4371 8.6107 21.5204 8.58055 21.5811Z"
      fill="#161514"
    />,
    <path
      key={2}
      d="M9.0657 22.1315C9.00858 22.1853 8.89691 22.1603 8.82114 22.0752C8.74279 21.9903 8.72812 21.8767 8.78603 21.822C8.84494 21.7682 8.95324 21.7934 9.03179 21.8783C9.11013 21.9642 9.12541 22.077 9.0657 22.1315Z"
      fill="#161514"
    />,
    <path
      key={3}
      d="M9.53797 22.8331C9.46458 22.885 9.34458 22.8364 9.2704 22.728C9.19701 22.6197 9.19701 22.4898 9.27198 22.4377C9.34636 22.3857 9.46458 22.4325 9.53975 22.54C9.61294 22.6501 9.61294 22.7801 9.53797 22.8331Z"
      fill="#161514"
    />,
    <path
      key={4}
      d="M10.185 23.511C10.1193 23.5846 9.97949 23.5648 9.87714 23.4644C9.77241 23.3661 9.74326 23.2267 9.80911 23.1531C9.87555 23.0792 10.0162 23.1 10.1193 23.1997C10.2233 23.2977 10.255 23.4381 10.185 23.511Z"
      fill="#161514"
    />,
    <path
      key={5}
      d="M11.0775 23.9045C11.0486 24 10.9139 24.0433 10.7782 24.0028C10.6428 23.961 10.5541 23.8493 10.5815 23.7528C10.6096 23.6568 10.7449 23.6116 10.8816 23.655C11.0168 23.6966 11.1057 23.8075 11.0775 23.9045Z"
      fill="#161514"
    />,
    <path
      key={6}
      d="M12.0578 23.9776C12.0611 24.078 11.9461 24.1614 11.8037 24.1632C11.6605 24.1664 11.5446 24.0851 11.5431 23.9863C11.5431 23.8848 11.6555 23.8023 11.7987 23.7998C11.9411 23.797 12.0578 23.8777 12.0578 23.9776Z"
      fill="#161514"
    />,
    <path
      key={7}
      d="M12.97 23.8196C12.987 23.9177 12.8881 24.0183 12.7466 24.0452C12.6076 24.071 12.4789 24.0105 12.4612 23.9132C12.444 23.8128 12.5447 23.7121 12.6836 23.6861C12.8252 23.6611 12.9519 23.72 12.97 23.8196Z"
      fill="#161514"
    />,
  ],
});

export const GitLabIcon = createIcon({
  displayName: "GitLab",
  viewBox: "4 4 24 24",
  path: [
    <path key={0} d="M16.0001 27.054L20.4192 13.4536H11.5811L16.0001 27.054Z" fill="#E24329" />,
    <path key={1} d="M16 27.0539L11.5809 13.4535H5.3877L16 27.0539Z" fill="#FC6D26" />,
    <path
      key={2}
      d="M5.38772 13.4536L4.04485 17.5866C3.92236 17.9635 4.05651 18.3765 4.37719 18.6095L16 27.054L5.38772 13.4536Z"
      fill="#FCA326"
    />,
    <path
      key={3}
      d="M5.3877 13.4536H11.5809L8.91929 5.26216C8.78239 4.84061 8.1861 4.84073 8.0492 5.26216L5.3877 13.4536Z"
      fill="#E24329"
    />,
    <path key={4} d="M16 27.0539L20.4191 13.4535H26.6123L16 27.0539Z" fill="#FC6D26" />,
    <path
      key={5}
      d="M26.6123 13.4536L27.9552 17.5866C28.0776 17.9635 27.9435 18.3765 27.6228 18.6095L16 27.054L26.6123 13.4536Z"
      fill="#FCA326"
    />,
    <path
      key={6}
      d="M26.6122 13.4536H20.4189L23.0806 5.26216C23.2175 4.84061 23.8138 4.84073 23.9507 5.26216L26.6122 13.4536Z"
      fill="#E24329"
    />,
  ],
});

export const DockerIcon = createIcon({
  displayName: "Docker",
  viewBox: "5 5 30 30",
  path: (
    <path
      d="M34.3808 17.4366C33.7052 16.9679 32.1571 16.7921 30.9467 17.0265C30.806 15.8547 30.1586 14.8293 29.0327 13.9211L28.3853 13.4524L27.9349 14.1262C27.372 15.0051 27.0905 16.2355 27.1749 17.4073C27.2031 17.8175 27.3438 18.5499 27.7661 19.1944C27.372 19.4287 26.5557 19.7217 25.4861 19.7217H5.13532L5.07903 19.956C4.882 21.1279 4.882 24.7898 7.1901 27.6022C8.93526 29.7408 11.5248 30.8247 14.9307 30.8247C22.3054 30.8247 27.766 27.28 30.3275 20.8642C31.3408 20.8935 33.5082 20.8642 34.6059 18.667C34.6341 18.6084 34.6904 18.4913 34.8874 18.0518L35 17.8175L34.3808 17.4366ZM21.4047 9.17523H18.3084V12.1048H21.4047V9.17523ZM21.4047 12.6907H18.3084V15.6203H21.4047V12.6907ZM17.7455 12.6907H14.6492V15.6203H17.7455V12.6907ZM14.0863 12.6907H10.99V15.6203H14.0863V12.6907ZM10.4271 16.2062H7.33084V19.1358H10.4271V16.2062ZM14.0863 16.2062H10.99V19.1358H14.0863V16.2062ZM17.7455 16.2062H14.6492V19.1358H17.7455V16.2062ZM21.4047 16.2062H18.3084V19.1358H21.4047V16.2062ZM25.0639 16.2062H21.9676V19.1358H25.0639V16.2062Z"
      fill="#2396ED"
    />
  ),
});

export const JsIcon = createIcon({
  displayName: "Javascript",
  viewBox: "5 5 30 30",
  path: [
    <rect key={0} fill="#FFCA28" height="26" rx="4" width="26" x="7" y="7" />,
    <path
      key={1}
      d="M21.9474 27.7567L23.7919 26.6285C23.9364 27.0483 24.8518 28.0453 26.0081 28.0453C27.1644 28.0453 27.7012 27.4615 27.7012 27.0745C27.7012 26.0199 26.5205 25.648 25.9534 25.4694C25.861 25.4403 25.7849 25.4163 25.7328 25.3953C25.7061 25.3846 25.6657 25.3703 25.6139 25.352C24.9832 25.1293 22.6563 24.3075 22.6563 21.9255C22.6563 19.3017 25.3955 19 26.015 19C26.4202 19 28.3688 19.0459 29.3393 20.7317L27.5498 21.8861C27.1575 21.1515 26.5057 20.9088 26.1045 20.9088C25.1134 20.9088 24.9069 21.5804 24.9069 21.8861C24.9069 22.744 25.9837 23.1284 26.8929 23.4531C27.1308 23.538 27.3572 23.6189 27.5498 23.703C28.5409 24.136 30 24.8444 30 27.0745C30 28.1916 28.9864 30 26.4348 30C23.0073 30 22.0988 28.0978 21.9474 27.7567Z"
      fill="#3E3E3E"
    />,
    <path
      key={2}
      d="M13 27.9807L14.9225 26.8531C15.0731 27.2727 15.6585 28.0463 16.5078 28.0463C17.3572 28.0463 17.7919 27.2399 17.7919 26.8531V19.2481H20.1563V26.8531C20.1945 27.9021 19.5652 30 16.7876 30C14.2338 30 13.1722 28.597 13 27.9807Z"
      fill="#3E3E3E"
    />,
  ],
});

export const TerraformIcon = createIcon({
  displayName: "Terraform",
  viewBox: "5 5 64 64",
  path: [
    <g key={0} className="C" transform="matrix(.826767 0 0 .826767 8.416322 51.138164)">
      <path
        key={1}
        d="M39.1 15.557v-24.43l-21.16-12.22v24.43zm0-27.1l-21.16-12.22v-24.44l21.16 12.22z"
        fill="#5c4ee5"
      />
      <path key={2} d="M62.6-23.773v-24.44l-21.17 12.22v24.44z" fill="#4040b2" />
      <g key={3} fill="#5c4ee5">
        <path key={4} d="M15.62-25.193v-24.44l-21.16-12.22v24.44z" />
        <path key={5} d="M53.64-.483" />
        <path key={6} d="M17.94-21.093" />
      </g>
    </g>,
  ],
});

export const HelmIcon = createIcon({
  displayName: "Helm",
  viewBox: "0 0 500 500",
  path: [
    <path
      key={0}
      className="cls-1"
      d="M136.52938,121.13478c-.572-.54252-1.19462-1.12636-1.81-1.71761-12.61677-12.12115-22.38092-26.13637-28.279-42.702-1.65073-4.63637-2.89692-9.36515-2.67587-14.35871.021-.4739.01959-.94915.05226-1.42214.445-6.44594,4.75912-9.70322,11.05839-8.17669a27.325,27.325,0,0,1,5.73149,2.19653c6.89022,3.45538,12.5062,8.56359,17.67051,14.16571a112.52651,112.52651,0,0,1,21.722,33.42965,8.29635,8.29635,0,0,0,.38946.861c.07116.12855.22232.21282.55927.51883A176.357,176.357,0,0,1,241.968,79.06864c-.17651-.8761-.28195-1.54571-.44772-2.2a112.49436,112.49436,0,0,1-2.65292-36.95637,84.07478,84.07478,0,0,1,4.44444-21.76378,31.32555,31.32555,0,0,1,5.47651-10.17139,15.687,15.687,0,0,1,3.16336-2.82149,7.026,7.026,0,0,1,8.03255-.056,17.27854,17.27854,0,0,1,5.8402,6.73185A53.05435,53.05435,0,0,1,271.08657,26.508a112.50469,112.50469,0,0,1,2.12263,33.00356,95.59806,95.59806,0,0,1-3.49052,19.91081c7.12171,1.31193,14.20955,2.32869,21.1473,3.97713a186.37909,186.37909,0,0,1,20.44069,6.0033A188.31671,188.31671,0,0,1,331.0769,97.9721c6.34538,3.16433,12.38553,6.94066,18.71757,10.53829.20571-.433.50439-.94982.706-1.50212A108.65959,108.65959,0,0,1,383.40128,60.246a37.75787,37.75787,0,0,1,11.822-6.883,17.24558,17.24558,0,0,1,3.67827-.84512c6.264-.71729,8.89351,3.2244,9.35653,7.93183a29.94372,29.94372,0,0,1-.77381,10.35466A87.90551,87.90551,0,0,1,396.75426,95.492c-6.79016,10.97178-14.85015,20.85494-25.09307,28.83042-.30234.2354-.56784.51814-1.07988.99029a177.77993,177.77993,0,0,1,26.59293,30.88244,10.96227,10.96227,0,0,1-1.689.29762c-10.59546.015-21.1911-.01829-31.78622.04607a4.004,4.004,0,0,1-3.17246-1.69,147.87522,147.87522,0,0,0-88.17776-46.54846,143.35862,143.35862,0,0,0-30.27955-1.16923,146.40735,146.40735,0,0,0-82.53728,31.81054,140.06663,140.06663,0,0,0-16.97616,15.84186,4.72839,4.72839,0,0,1-3.86326,1.75742c-10.12056-.07028-20.24188-.035-30.36293-.03495h-2.15212c.618-2.408,6.84026-10.93786,13.88352-18.55281C125.31349,132.2744,130.87768,126.8839,136.52938,121.13478Z"
      fill="#0f1689"
    />,
    <path
      key={1}
      className="cls-1"
      d="M394.52934,347.9123a176.63854,176.63854,0,0,1-23.97343,27.16338c.70941.59068,1.28594,1.07041,1.86212,1.55057A108.31456,108.31456,0,0,1,406.10131,424.772a34.61831,34.61831,0,0,1,2.202,14.42026,14.88544,14.88544,0,0,1-.74786,3.69206,7.20762,7.20762,0,0,1-8.15793,5.02308,22.23329,22.23329,0,0,1-6.76276-2.00629,51.23237,51.23237,0,0,1-9.18151-5.8151,107.59183,107.59183,0,0,1-32.936-46.7072c-.18746-.51334-.39218-1.0204-.72243-1.87691a194.65008,194.65008,0,0,1-25.01223,14.00774,181.66925,181.66925,0,0,1-26.6869,9.72442,187.55649,187.55649,0,0,1-28.3045,5.38805c.16807.84015.26446,1.5098.43745,2.15907a109.172,109.172,0,0,1,2.9708,36.44311,80.804,80.804,0,0,1-4.42286,22.4773,78.24971,78.24971,0,0,1-4.16475,8.74473,13.39,13.39,0,0,1-2.33865,2.97083c-3.98009,4.109-8.73225,4.144-12.61157-.07366a27.28012,27.28012,0,0,1-3.907-5.61776c-3.07685-5.77569-4.6604-12.056-5.791-18.46021a116.86329,116.86329,0,0,1-1.35893-26.465,94.4795,94.4795,0,0,1,2.88466-19.18513c.14009-.53269.268-1.0696.37134-1.61034.02629-.13754-.06342-.2973-.17067-.73825a176.12108,176.12108,0,0,1-80.96855-24.99386c-.40992.90921-.76206,1.67473-1.10168,2.44579a110.47729,110.47729,0,0,1-30.90112,41.42041,38.16071,38.16071,0,0,1-12.04706,6.95909,12.08987,12.08987,0,0,1-6.51516.70023,7.11858,7.11858,0,0,1-5.40329-4.4892c-1.41614-3.424-1.16526-6.985-.68438-10.51691a55.45267,55.45267,0,0,1,4.30768-14.25037A112.49985,112.49985,0,0,1,134.88761,380.779c.459-.43461.92981-.857,1.38087-1.29954a3.76029,3.76029,0,0,0,.36534-.65529,178.90466,178.90466,0,0,1-28.469-31.31672c.98458-.08018,1.64327-.18,2.30205-.1806,10.51436-.00976,21.029.02736,31.54284-.04358a4.70554,4.70554,0,0,1,3.70344,1.62615,146.94611,146.94611,0,0,0,39.40276,28.88494,139.94667,139.94667,0,0,0,49.70395,14.77367q70.68048,6.87067,121.59971-42.85452a7.64571,7.64571,0,0,1,5.99261-2.44347c9.80139.12121,19.60512.04986,29.408.04986h2.53353Z"
      fill="#0f1689"
    />,
    <path
      key={2}
      className="cls-1"
      d="M350.73576,197.76167c2.78711,0,5.47037.18919,8.11487-.0501,2.9951-.271,5.139.8001,7.32354,2.81308,12.61275,11.62214,25.35732,23.10129,38.05863,34.62729.63855.57948,1.29039,1.14432,2.1101,1.8701.76445-.65718,1.48119-1.24318,2.16483-1.8655Q428.14636,217.27914,447.756,199.37a5.44772,5.44772,0,0,1,4.20358-1.64576c3.21888.13038,6.44673.03746,9.8412.03746V303.13036c-1.72309.50368-24.8756.60366-27.63911.0611v-53.362l-.53656-.25427c-9.01079,8.21784-18.0216,16.43564-27.23786,24.8408-9.22584-8.31119-18.34194-16.52347-27.458-24.73577l-.52449.19192c-.023,4.45359-.00774,8.90828-.01046,13.36233q-.00408,6.63942-.00058,13.27882v26.87211h-27.428C350.45161,301.61243,350.21289,203.72342,350.73576,197.76167Z"
      fill="#0f1689"
    />,
    <path
      key={3}
      className="cls-1"
      d="M97.63436,197.88229h27.26325c.55054,1.75251.65821,102.97139.09469,105.525H97.70468c-.15021-6.70344-.04736-13.38394-.06622-20.06131-.01871-6.62261-.0041-13.24531-.0041-20.03958H63.84679V303.047c-2.05946.61518-25.33374.67417-27.64758.123V197.89436H63.73742v37.18876c1.96793.56844,30.92319.67339,33.872.12942.00818-2.97713.02-6.02646.024-9.0758q.0063-4.7433.00094-9.4866,0-4.625,0-9.25C97.63437,204.32179,97.63436,201.24346,97.63436,197.88229Z"
      fill="#0f1689"
    />,
    <path
      key={4}
      className="cls-1"
      d="M157.5757,303.3683V198.1946c1.617-.52913,61.545-.73586,65.46219-.20457v22.41432c-.87869.063-1.7857.18341-2.69279.18454q-16.0086.01994-32.01725.00881l-2.96767,0v17.43353H218.7067V261.2229H185.65838c-.55339,1.98509-.70531,15.81681-.25622,19.64583.84488.05679,1.75.16952,2.6553.17059q16.00862.01863,32.01727.00822h2.96945V303.3683Z"
      fill="#0f1689"
    />,
    <path
      key={5}
      className="cls-1"
      d="M254.28291,303.40855c-.50074-2.82232-.39948-103.60181.09747-105.51735h27.16208v77.76453c1.17173.06084,2.09122.14921,3.01077.15005q16.128.01468,32.2561.00658c.92562,0,1.85125,0,2.90733,0v27.59622Z"
      fill="#0f1689"
    />,
  ],
});

export const WorkOSIcon = createIcon({
  displayName: "WorkOS",
  viewBox: "0 0 55.4 48",
  path: [
    <g key={0}>
      <path
        className="st0"
        d="M0,24c0,1.1,0.3,2.1,0.8,3l9.7,16.8c1,1.7,2.5,3.1,4.4,3.7c3.6,1.2,7.5-0.3,9.4-3.5l2.3-4.1 l-9.2-16l9.8-16.9L29.5,3c0.7-1.2,1.6-2.2,2.7-3H17.2c-2.6,0-5.1,1.4-6.4,3.7L0.8,21C0.3,21.9,0,22.9,0,24z"
        fill="#6363F1"
      />
      <path
        className="st0"
        d="M55.4,24c0-1.1-0.3-2.1-0.8-3l-9.8-17c-1.9-3.3-5.8-4.7-9.4-3.5c-1.9,0.6-3.4,2-4.4,3.7 L28.7,8L38,24l-9.8,16.9L25.9,45c-0.7,1.2-1.6,2.2-2.7,3h15.1c2.6,0,5.1-1.4,6.4-3.7l10-17.3C55.1,26.1,55.4,25.1,55.4,24z"
        fill="#6363F1"
      />
    </g>,
  ],
});

export const AwsIcon = createIcon({
  displayName: "AWS",
  viewBox: "0 0 304 182",
  path: [
    <g key={0}>
      <path
        d="M86.4,66.4c0,3.7,0.4,6.7,1.1,8.9c0.8,2.2,1.8,4.6,3.2,7.2c0.5,0.8,0.7,1.6,0.7,2.3c0,1-0.6,2-1.9,3l-6.3,4.2
		c-0.9,0.6-1.8,0.9-2.6,0.9c-1,0-2-0.5-3-1.4C76.2,90,75,88.4,74,86.8c-1-1.7-2-3.6-3.1-5.9c-7.8,9.2-17.6,13.8-29.4,13.8
		c-8.4,0-15.1-2.4-20-7.2c-4.9-4.8-7.4-11.2-7.4-19.2c0-8.5,3-15.4,9.1-20.6c6.1-5.2,14.2-7.8,24.5-7.8c3.4,0,6.9,0.3,10.6,0.8
		c3.7,0.5,7.5,1.3,11.5,2.2v-7.3c0-7.6-1.6-12.9-4.7-16c-3.2-3.1-8.6-4.6-16.3-4.6c-3.5,0-7.1,0.4-10.8,1.3c-3.7,0.9-7.3,2-10.8,3.4
		c-1.6,0.7-2.8,1.1-3.5,1.3c-0.7,0.2-1.2,0.3-1.6,0.3c-1.4,0-2.1-1-2.1-3.1v-4.9c0-1.6,0.2-2.8,0.7-3.5c0.5-0.7,1.4-1.4,2.8-2.1
		c3.5-1.8,7.7-3.3,12.6-4.5c4.9-1.3,10.1-1.9,15.6-1.9c11.9,0,20.6,2.7,26.2,8.1c5.5,5.4,8.3,13.6,8.3,24.6V66.4z M45.8,81.6
		c3.3,0,6.7-0.6,10.3-1.8c3.6-1.2,6.8-3.4,9.5-6.4c1.6-1.9,2.8-4,3.4-6.4c0.6-2.4,1-5.3,1-8.7v-4.2c-2.9-0.7-6-1.3-9.2-1.7
		c-3.2-0.4-6.3-0.6-9.4-0.6c-6.7,0-11.6,1.3-14.9,4c-3.3,2.7-4.9,6.5-4.9,11.5c0,4.7,1.2,8.2,3.7,10.6
		C37.7,80.4,41.2,81.6,45.8,81.6z M126.1,92.4c-1.8,0-3-0.3-3.8-1c-0.8-0.6-1.5-2-2.1-3.9L96.7,10.2c-0.6-2-0.9-3.3-0.9-4
		c0-1.6,0.8-2.5,2.4-2.5h9.8c1.9,0,3.2,0.3,3.9,1c0.8,0.6,1.4,2,2,3.9l16.8,66.2l15.6-66.2c0.5-2,1.1-3.3,1.9-3.9c0.8-0.6,2.2-1,4-1
		h8c1.9,0,3.2,0.3,4,1c0.8,0.6,1.5,2,1.9,3.9l15.8,67l17.3-67c0.6-2,1.3-3.3,2-3.9c0.8-0.6,2.1-1,3.9-1h9.3c1.6,0,2.5,0.8,2.5,2.5
		c0,0.5-0.1,1-0.2,1.6c-0.1,0.6-0.3,1.4-0.7,2.5l-24.1,77.3c-0.6,2-1.3,3.3-2.1,3.9c-0.8,0.6-2.1,1-3.8,1h-8.6c-1.9,0-3.2-0.3-4-1
		c-0.8-0.7-1.5-2-1.9-4L156,23l-15.4,64.4c-0.5,2-1.1,3.3-1.9,4c-0.8,0.7-2.2,1-4,1H126.1z M254.6,95.1c-5.2,0-10.4-0.6-15.4-1.8
		c-5-1.2-8.9-2.5-11.5-4c-1.6-0.9-2.7-1.9-3.1-2.8c-0.4-0.9-0.6-1.9-0.6-2.8v-5.1c0-2.1,0.8-3.1,2.3-3.1c0.6,0,1.2,0.1,1.8,0.3
		c0.6,0.2,1.5,0.6,2.5,1c3.4,1.5,7.1,2.7,11,3.5c4,0.8,7.9,1.2,11.9,1.2c6.3,0,11.2-1.1,14.6-3.3c3.4-2.2,5.2-5.4,5.2-9.5
		c0-2.8-0.9-5.1-2.7-7c-1.8-1.9-5.2-3.6-10.1-5.2L246,52c-7.3-2.3-12.7-5.7-16-10.2c-3.3-4.4-5-9.3-5-14.5c0-4.2,0.9-7.9,2.7-11.1
		c1.8-3.2,4.2-6,7.2-8.2c3-2.3,6.4-4,10.4-5.2c4-1.2,8.2-1.7,12.6-1.7c2.2,0,4.5,0.1,6.7,0.4c2.3,0.3,4.4,0.7,6.5,1.1
		c2,0.5,3.9,1,5.7,1.6c1.8,0.6,3.2,1.2,4.2,1.8c1.4,0.8,2.4,1.6,3,2.5c0.6,0.8,0.9,1.9,0.9,3.3v4.7c0,2.1-0.8,3.2-2.3,3.2
		c-0.8,0-2.1-0.4-3.8-1.2c-5.7-2.6-12.1-3.9-19.2-3.9c-5.7,0-10.2,0.9-13.3,2.8c-3.1,1.9-4.7,4.8-4.7,8.9c0,2.8,1,5.2,3,7.1
		c2,1.9,5.7,3.8,11,5.5l14.2,4.5c7.2,2.3,12.4,5.5,15.5,9.6c3.1,4.1,4.6,8.8,4.6,14c0,4.3-0.9,8.2-2.6,11.6
		c-1.8,3.4-4.2,6.4-7.3,8.8c-3.1,2.5-6.8,4.3-11.1,5.6C264.4,94.4,259.7,95.1,254.6,95.1z"
        fill="#252F3E"
      />
      <g>
        <path
          clipRule="evenodd"
          d="M273.5,143.7c-32.9,24.3-80.7,37.2-121.8,37.2c-57.6,0-109.5-21.3-148.7-56.7c-3.1-2.8-0.3-6.6,3.4-4.4
			c42.4,24.6,94.7,39.5,148.8,39.5c36.5,0,76.6-7.6,113.5-23.2C274.2,133.6,278.9,139.7,273.5,143.7z"
          fill="#FF9900"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M287.2,128.1c-4.2-5.4-27.8-2.6-38.5-1.3c-3.2,0.4-3.7-2.4-0.8-4.5c18.8-13.2,49.7-9.4,53.3-5
			c3.6,4.5-1,35.4-18.6,50.2c-2.7,2.3-5.3,1.1-4.1-1.9C282.5,155.7,291.4,133.4,287.2,128.1z"
          fill="#FF9900"
          fillRule="evenodd"
        />
      </g>
    </g>,
  ],
});

export const AzureIcon = createIcon({
  displayName: "Microsoft Azure",
  viewBox: "0 0 96 96",
  path: [
    <defs key={0}>
      <linearGradient id="azure-gradient" x1="0%" x2="100%" y1="13.48%" y2="85.36%">
        <stop offset="0%" stopColor="#114A8B" />
        <stop offset="100%" stopColor="#0669BC" />
      </linearGradient>
    </defs>,
    <path
      key={1}
      d="M46.09 41.68L36.67 61.48 21.18 63.22C24.67 63.75 28.13 64.28 31.59 64.81L50.91 34.52 46.09 41.68ZM73.11 67.51H17.94C17.94 67.51 44.47 63.07 51.17 61.89L66.51 32.66 51.79 9.58 23.34 67.51H5L37.21 5 51.44 23.19 73.11 67.51Z"
      fill="url(#azure-gradient)"
    />,
  ],
});

export const RdsIcon = createIcon({
  displayName: "RDS",
  viewBox: "0 0 256 256",
  path: [
    <defs key={0}>
      <linearGradient x1="0%" x2="100%" y1="100%" y2="0%">
        <stop offset="0%" stopColor="#2E27AD" />
        <stop offset="100%" stopColor="#527FFF" />
      </linearGradient>
    </defs>,
    <path key={1} d="M0 0h256v256H0z" fill="url(#logosAwsRds0)" />,
    <path
      key={2}
      d="m49.325 44.8l29.737 29.738l-4.524 4.524L44.8 49.325V73.6h-6.4v-32a3.2 3.2 0 0 1 3.2-3.2h32v6.4H49.325ZM217.6 41.6v32h-6.4V49.325l-29.738 29.737l-4.524-4.524L206.675 44.8H182.4v-6.4h32a3.2 3.2 0 0 1 3.2 3.2Zm-6.4 140.8h6.4v32a3.2 3.2 0 0 1-3.2 3.2h-32v-6.4h24.275l-29.737-29.738l4.524-4.524l29.738 29.737V182.4Zm-1.6-56.918c0-10.621-12.262-21.114-32.8-28.068l2.051-6.06C202.458 99.344 216 111.782 216 125.482c0 13.702-13.542 26.144-37.152 34.13l-2.051-6.063c20.54-6.95 32.803-17.44 32.803-28.067Zm-163.02 0c0 10.176 11.478 20.39 30.706 27.328l-2.172 6.019c-22.202-8.01-34.935-20.163-34.935-33.347c0-13.181 12.733-25.335 34.935-33.348l2.172 6.02c-19.228 6.94-30.707 17.155-30.707 27.328Zm32.482 55.98L49.325 211.2H73.6v6.4h-32a3.2 3.2 0 0 1-3.2-3.2v-32h6.4v24.275l29.738-29.737l4.524 4.524ZM128 100.115c-22.867 0-35.2-5.907-35.2-8.32c0-2.416 12.333-8.32 35.2-8.32c22.864 0 35.2 5.904 35.2 8.32c0 2.413-12.336 8.32-35.2 8.32Zm.093 24.784c-21.895 0-35.293-5.98-35.293-9.235v-15.555c7.882 4.349 21.862 6.406 35.2 6.406c13.338 0 27.318-2.057 35.2-6.406v15.555c0 3.258-13.328 9.235-35.107 9.235Zm0 24.435c-21.895 0-35.293-5.98-35.293-9.235v-15.74c7.78 4.572 21.574 6.94 35.293 6.94c13.641 0 27.357-2.365 35.107-6.925V140.1c0 3.258-13.328 9.235-35.107 9.235ZM128 171.258c-22.774 0-35.2-6.122-35.2-9.268v-13.196c7.78 4.572 21.574 6.94 35.293 6.94c13.641 0 27.357-2.361 35.107-6.924v13.18c0 3.146-12.426 9.268-35.2 9.268Zm0-94.183c-20.035 0-41.6 4.605-41.6 14.72v70.195c0 10.285 20.928 15.668 41.6 15.668s41.6-5.383 41.6-15.668V91.795c0-10.115-21.565-14.72-41.6-14.72Z"
      fill="#FFF"
    />,
  ],
});

export const CloudSqlIcon = createIcon({
  displayName: "Cloud SQL",
  viewBox: "0 0 24 24",
  path: [
    <g key={0} data-name="Product Icons">
      <g>
        <polygon
          fill="#AECBFA"
          fillRule="evenodd"
          points="4.67 10.44 4.67 13.45 12 17.35 12 14.34 4.67 10.44"
        />
        <polygon fill="#AECBFA" fillRule="evenodd" points="4.67 15.09 4.67 18.1 12 22 12 18.99 4.67 15.09" />
        <polygon
          fill="#669DF6"
          fillRule="evenodd"
          points="12 17.35 19.33 13.45 19.33 10.44 12 14.34 12 17.35"
        />
        <polygon fill="#669DF6" fillRule="evenodd" points="12 22 19.33 18.1 19.33 15.09 12 18.99 12 22" />
        <polygon fill="#4285F4" fillRule="evenodd" points="19.33 8.91 19.33 5.9 12 2 12 5.01 19.33 8.91" />
        <polygon fill="#669DF6" fillRule="evenodd" points="12 2 4.67 5.9 4.67 8.91 12 5.01 12 2" />
        <polygon fill="#AECBFA" fillRule="evenodd" points="4.67 5.87 4.67 8.89 12 12.79 12 9.77 4.67 5.87" />
        <polygon fill="#669DF6" fillRule="evenodd" points="12 12.79 19.33 8.89 19.33 5.87 12 9.77 12 12.79" />
      </g>
    </g>,
  ],
});

export const AuroraIcon = createIcon({
  displayName: "Aurora",
  viewBox: "0 0 256 256",
  path: [
    <defs key={0}>
      <linearGradient x1="0%" x2="100%" y1="100%" y2="0%">
        <stop offset="0%" stopColor="#2E27AD" />
        <stop offset="100%" stopColor="#527FFF" />
      </linearGradient>
    </defs>,
    <path key={1} d="M0 0h256v256H0z" fill="url(#logosAwsAurora0)" />,
    <path
      key={2}
      d="M144.292 57.744h-9.626v-6.457h9.626V41.6h6.417v9.687h9.625v6.457h-9.625v9.687h-6.417v-9.687Zm38.502 35.518h-9.625v-6.458h9.625v-9.686h6.418v9.686h9.625v6.458h-9.625v9.687h-6.418v-9.687Zm-16.71 102.046c-6.128-15.57-20.272-29.803-35.75-35.973c15.478-6.167 29.622-20.4 35.75-35.973c6.129 15.573 20.272 29.806 35.747 35.973c-15.475 6.17-29.618 20.403-35.747 35.973Zm51.507-39.202c-22.569 0-48.298-25.893-48.298-48.605a3.218 3.218 0 0 0-3.209-3.228a3.218 3.218 0 0 0-3.208 3.228c0 22.712-25.733 48.605-48.302 48.605c-1.771 0-3.209 1.446-3.209 3.229a3.218 3.218 0 0 0 3.209 3.229c22.569 0 48.302 25.892 48.302 48.607a3.218 3.218 0 0 0 3.208 3.229a3.218 3.218 0 0 0 3.209-3.229c0-22.715 25.73-48.607 48.298-48.607a3.218 3.218 0 0 0 3.209-3.23a3.22 3.22 0 0 0-3.209-3.228ZM41.617 92.49c9.344 6.84 27.498 10.459 44.92 10.459c17.423 0 35.577-3.62 44.92-10.459v30.927c-4.623 6.186-21.626 12.282-44.278 12.282c-26.076 0-45.562-8.201-45.562-15.534V92.49Zm44.92-25.059c27.831 0 44.92 8.463 44.92 14.53s-17.089 14.53-44.92 14.53c-27.831 0-44.92-8.463-44.92-14.53s17.089-14.53 44.92-14.53Zm44.92 121.183c0 7.443-19.216 15.77-44.936 15.77c-25.7 0-44.904-8.327-44.904-15.77v-20.632c9.459 7.22 27.976 11.042 45.745 11.042c12.356 0 24.305-1.756 33.632-4.946l-2.06-6.116c-8.682 2.968-19.896 4.605-31.572 4.605c-26.182 0-45.745-8.202-45.745-15.535v-25.898c9.433 7.206 27.87 11.023 45.562 11.023c18.956 0 35.214-3.93 44.278-10.152v9.69h6.417V81.961c0-13.632-26.448-20.988-51.337-20.988c-23.875 0-49.123 6.787-51.138 19.374H35.2v108.267c0 14.436 26.442 22.228 51.321 22.228c24.895 0 51.353-7.792 51.353-22.228v-11.401h-6.417v11.401Z"
      fill="#FFF"
    />,
  ],
});

export const PostgresIcon = createIcon({
  displayName: "Postgres",
  viewBox: "0 0 25.6 25.6",
  path: [
    <g key={0} fill="none" stroke="#fff">
      <path
        d="M18.983 18.636c.163-1.357.114-1.555 1.124-1.336l.257.023c.777.035 1.793-.125 2.4-.402 1.285-.596 2.047-1.592.78-1.33-2.89.596-3.1-.383-3.1-.383 3.053-4.53 4.33-10.28 3.227-11.687-3.004-3.84-8.205-2.024-8.292-1.976l-.028.005c-.57-.12-1.2-.19-1.93-.2-1.308-.02-2.3.343-3.054.914 0 0-9.277-3.822-8.846 4.807.092 1.836 2.63 13.9 5.66 10.25C8.29 15.987 9.36 14.86 9.36 14.86c.53.353 1.167.533 1.834.468l.052-.044a2.01 2.01 0 0 0 .021.518c-.78.872-.55 1.025-2.11 1.346-1.578.325-.65.904-.046 1.056.734.184 2.432.444 3.58-1.162l-.046.183c.306.245.285 1.76.33 2.842s.116 2.093.337 2.688.48 2.13 2.53 1.7c1.713-.367 3.023-.896 3.143-5.81"
        fill="#000"
        stroke="#000"
        strokeLinecap="butt"
        strokeLinejoin="miter"
        strokeWidth="2.149"
      />
      ,
      <path
        d="M23.535 15.6c-2.89.596-3.1-.383-3.1-.383 3.053-4.53 4.33-10.28 3.228-11.687-3.004-3.84-8.205-2.023-8.292-1.976l-.028.005a10.31 10.31 0 0 0-1.929-.201c-1.308-.02-2.3.343-3.054.914 0 0-9.278-3.822-8.846 4.807.092 1.836 2.63 13.9 5.66 10.25C8.29 15.987 9.36 14.86 9.36 14.86c.53.353 1.167.533 1.834.468l.052-.044a2.02 2.02 0 0 0 .021.518c-.78.872-.55 1.025-2.11 1.346-1.578.325-.65.904-.046 1.056.734.184 2.432.444 3.58-1.162l-.046.183c.306.245.52 1.593.484 2.815s-.06 2.06.18 2.716.48 2.13 2.53 1.7c1.713-.367 2.6-1.32 2.725-2.906.088-1.128.286-.962.3-1.97l.16-.478c.183-1.53.03-2.023 1.085-1.793l.257.023c.777.035 1.794-.125 2.39-.402 1.285-.596 2.047-1.592.78-1.33z"
        fill="#336791"
        stroke="none"
      />
      ,
      <g strokeWidth=".716">
        <g strokeLinecap="round">
          <path
            d="M12.814 16.467c-.08 2.846.02 5.712.298 6.4s.875 2.05 2.926 1.612c1.713-.367 2.337-1.078 2.607-2.647l.633-5.017M10.356 2.2S1.072-1.596 1.504 7.033c.092 1.836 2.63 13.9 5.66 10.25C8.27 15.95 9.27 14.907 9.27 14.907m6.1-13.4c-.32.1 5.164-2.005 8.282 1.978 1.1 1.407-.175 7.157-3.228 11.687"
            strokeLinejoin="round"
          />
          ,
          <path
            d="M20.425 15.17s.2.98 3.1.382c1.267-.262.504.734-.78 1.33-1.054.49-3.418.615-3.457-.06-.1-1.745 1.244-1.215 1.147-1.652-.088-.394-.69-.78-1.086-1.744-.347-.84-4.76-7.29 1.224-6.333.22-.045-1.56-5.7-7.16-5.782S7.99 8.196 7.99 8.196"
            strokeLinejoin="bevel"
          />
          ,
        </g>
        <g strokeLinejoin="round">
          <path d="M11.247 15.768c-.78.872-.55 1.025-2.11 1.346-1.578.325-.65.904-.046 1.056.734.184 2.432.444 3.58-1.163.35-.49-.002-1.27-.482-1.468-.232-.096-.542-.216-.94.23z" />
          <path
            d="M11.196 15.753c-.08-.513.168-1.122.433-1.836.398-1.07 1.316-2.14.582-5.537-.547-2.53-4.22-.527-4.22-.184s.166 1.74-.06 3.365c-.297 2.122 1.35 3.916 3.246 3.733"
            strokeLinecap="round"
          />
          ,
        </g>
      </g>
      <g fill="#fff" strokeLinejoin="miter">
        <path
          d="M10.322 8.145c-.017.117.215.43.516.472s.558-.202.575-.32-.215-.246-.516-.288-.56.02-.575.136z"
          strokeWidth=".239"
        />
        ,
        <path
          d="M19.486 7.906c.016.117-.215.43-.516.472s-.56-.202-.575-.32.215-.246.516-.288.56.02.575.136z"
          strokeWidth=".119"
        />
        ,
      </g>
      <path
        d="M20.562 7.095c.05.92-.198 1.545-.23 2.524-.046 1.422.678 3.05-.413 4.68"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth=".716"
      />
    </g>,
  ],
});

export const MysqlIcon = createIcon({
  displayName: "Mysql",
  viewBox: "0 0 25.6 25.6",
  path: [
    <path
      key={0}
      d="M179.076 94.886c-3.568-.1-6.336.268-8.656 1.25-.668.27-1.74.27-1.828 1.116.357.355.4.936.713 1.428.535.893 1.473 2.096 2.32 2.72l2.855 2.053c1.74 1.07 3.703 1.695 5.398 2.766.982.625 1.963 1.428 2.945 2.098.5.357.803.938 1.428 1.16v-.135c-.312-.4-.402-.98-.713-1.428l-1.34-1.293c-1.293-1.74-2.9-3.258-4.64-4.506-1.428-.982-4.55-2.32-5.13-3.97l-.088-.1c.98-.1 2.14-.447 3.078-.715 1.518-.4 2.9-.312 4.46-.713l2.143-.625v-.4c-.803-.803-1.383-1.874-2.23-2.632-2.275-1.963-4.775-3.882-7.363-5.488-1.383-.892-3.168-1.473-4.64-2.23-.537-.268-1.428-.402-1.74-.848-.805-.98-1.25-2.275-1.83-3.436l-3.658-7.763c-.803-1.74-1.295-3.48-2.275-5.086-4.596-7.585-9.594-12.18-17.268-16.687-1.65-.937-3.613-1.34-5.7-1.83l-3.346-.18c-.715-.312-1.428-1.16-2.053-1.562-2.543-1.606-9.102-5.086-10.977-.5-1.205 2.9 1.785 5.755 2.8 7.228.76 1.026 1.74 2.186 2.277 3.346.3.758.4 1.562.713 2.365.713 1.963 1.383 4.15 2.32 5.98.5.937 1.025 1.92 1.65 2.767.357.5.982.714 1.115 1.517-.625.893-.668 2.23-1.025 3.347-1.607 5.042-.982 11.288 1.293 15 .715 1.115 2.4 3.57 4.686 2.632 2.008-.803 1.56-3.346 2.14-5.577.135-.535.045-.892.312-1.25v.1l1.83 3.703c1.383 2.186 3.793 4.462 5.8 5.98 1.07.803 1.918 2.187 3.256 2.677v-.135h-.088c-.268-.4-.67-.58-1.027-.892-.803-.803-1.695-1.785-2.32-2.677-1.873-2.498-3.523-5.265-4.996-8.12-.715-1.383-1.34-2.9-1.918-4.283-.27-.536-.27-1.34-.715-1.606-.67.98-1.65 1.83-2.143 3.034-.848 1.918-.936 4.283-1.248 6.737-.18.045-.1 0-.18.1-1.426-.356-1.918-1.83-2.453-3.078-1.338-3.168-1.562-8.254-.402-11.913.312-.937 1.652-3.882 1.117-4.774-.27-.848-1.16-1.338-1.652-2.008-.58-.848-1.203-1.918-1.605-2.855-1.07-2.5-1.605-5.265-2.766-7.764-.537-1.16-1.473-2.365-2.232-3.435-.848-1.205-1.783-2.053-2.453-3.48-.223-.5-.535-1.294-.178-1.83.088-.357.268-.5.623-.58.58-.5 2.232.134 2.812.4 1.65.67 3.033 1.294 4.416 2.23.625.446 1.295 1.294 2.098 1.518h.938c1.428.312 3.033.1 4.37.5 2.365.76 4.506 1.874 6.426 3.08 5.844 3.703 10.664 8.968 13.92 15.26.535 1.026.758 1.963 1.25 3.034.938 2.187 2.098 4.417 3.033 6.56.938 2.097 1.83 4.24 3.168 5.98.67.937 3.346 1.427 4.55 1.918.893.4 2.275.76 3.08 1.25 1.516.937 3.033 2.008 4.46 3.034.713.534 2.945 1.65 3.078 2.54zm-45.5-38.772a7.09 7.09 0 0 0-1.828.223v.1h.088c.357.714.982 1.205 1.428 1.83l1.027 2.142.088-.1c.625-.446.938-1.16.938-2.23-.268-.312-.312-.625-.535-.937-.268-.446-.848-.67-1.206-1.026z"
      fill="#00678c"
      fillRule="evenodd"
      transform="matrix(.390229 0 0 .38781 -46.300037 -16.856717)"
    />,
  ],
});

export const MariadbIcon = createIcon({
  displayName: "Mariadb",
  viewBox: "0 0 160 61",
  path: [
    <path
      key="0"
      d="M118.853 4.90644C118.638 4.72862 118.365 4.63697 118.086 4.64915C117.322 4.64915 116.333 5.16915 115.801 5.44812L115.59 5.55645C114.698 5.98972 113.726 6.23491 112.735 6.27688C111.72 6.30938 110.845 6.36897 109.705 6.48814C102.952 7.18419 99.9406 12.3735 97.0397 17.3921C95.4597 20.1221 93.8282 22.9578 91.5918 25.1245C91.1291 25.5744 90.6374 25.9933 90.1198 26.3785C87.805 28.1037 84.8987 29.336 82.638 30.2081C80.461 31.0423 78.0841 31.7926 75.7883 32.5184C73.6842 33.182 71.6989 33.8103 69.8731 34.4901C69.0493 34.7961 68.3497 35.0318 67.7312 35.2376C66.0674 35.7793 64.8681 36.1937 63.1152 37.4043C62.4318 37.8729 61.7458 38.3793 61.2812 38.7585C59.8897 39.8718 58.6581 41.1724 57.6213 42.6234C56.7297 43.9618 55.6994 45.202 54.5476 46.323C54.1776 46.6859 53.5212 46.8647 52.538 46.8647C51.3874 46.8647 49.991 46.6264 48.5136 46.3745C46.9902 46.1036 45.4155 45.8463 44.065 45.8463C42.9684 45.8463 42.1284 46.0251 41.5018 46.388C41.5018 46.388 40.4457 47.0055 40 47.8045L40.4376 48.0022C41.1161 48.3711 41.7443 48.8263 42.3067 49.3564C42.8934 49.8998 43.5469 50.3658 44.2514 50.7431C44.4763 50.8258 44.6808 50.956 44.851 51.125C44.6673 51.3958 44.3972 51.7452 44.1136 52.119C42.5551 54.1638 41.6449 55.4557 42.1662 56.1599C42.4161 56.29 42.6951 56.3534 42.9765 56.344C46.3744 56.344 48.2002 55.4584 50.5096 54.3371C51.1794 54.0121 51.8601 53.679 52.6704 53.335C54.0209 52.7473 55.474 51.8102 57.0163 50.8189C59.034 49.5 61.1434 48.1458 63.1908 47.493C64.8734 46.9786 66.626 46.7318 68.3848 46.7618C70.5456 46.7618 72.8199 47.0516 75.0131 47.3332C76.6472 47.5445 78.3407 47.7612 80.0018 47.8614C80.6474 47.8993 81.2443 47.9183 81.825 47.9183C82.6018 47.9205 83.3782 47.8799 84.1506 47.7964L84.3369 47.7314C85.5011 47.0137 86.0467 45.4726 86.5761 43.983C86.9164 43.0242 87.2027 42.1629 87.6565 41.6159C87.6832 41.5891 87.7121 41.5647 87.7429 41.5427C87.7642 41.5309 87.7888 41.5265 87.8128 41.5305C87.8368 41.5344 87.8588 41.5464 87.8752 41.5644C87.8752 41.5644 87.8752 41.5779 87.8752 41.6077C87.6051 47.4335 85.2661 51.1331 82.9 54.4211L81.3199 56.1192C81.3199 56.1192 83.532 56.1192 84.7907 55.6317C89.3824 54.2559 92.8478 51.2225 95.3705 46.3853C95.9926 45.1436 96.5489 43.8698 97.037 42.5692C97.0803 42.4609 97.4773 42.2604 97.4395 42.8211C97.426 42.9863 97.4152 43.1705 97.4017 43.3628C97.4017 43.4765 97.4017 43.593 97.3801 43.7094C97.3152 44.5219 97.1235 46.2391 97.1235 46.2391L98.5415 45.478C101.961 43.3113 104.597 38.94 106.596 32.1392C107.428 29.3063 108.038 26.4922 108.576 24.0141C109.219 21.0349 109.772 18.4809 110.407 17.4896C111.404 15.935 112.924 14.8841 114.396 13.8631C114.596 13.7249 114.799 13.5922 114.996 13.446C116.846 12.1432 118.686 10.6401 119.091 7.83691V7.77462C119.385 5.68375 119.137 5.1502 118.853 4.90644Z"
      fill="#003545"
    />,
  ],
});

export const AnthropicIcon = createIcon({
  displayName: "Anthropic",
  viewBox: "0 0 24 24",
  path: [
    <path
      key="0"
      d="M13.827 3.52h-3.603L3 20.48h3.511l1.27-3.594h8.418l1.27 3.594H21L13.827 3.52Zm-4.234 10.63L12 6.842l2.407 7.308H9.593Z"
      fill="#191918"
    />,
  ],
});

export const OpenAiIcon = createIcon({
  displayName: "OpenAI",
  viewBox: "0 0 24 24",
  path: [
    <path
      key="0"
      d="M22.2819 9.8211a5.9847 5.9847 0 0 0-.5157-4.9108 6.0462 6.0462 0 0 0-6.5098-2.9A6.0651 6.0651 0 0 0 4.9807 4.1818a5.9847 5.9847 0 0 0-3.9977 2.9 6.0462 6.0462 0 0 0 .7427 7.0966 5.98 5.98 0 0 0 .511 4.9107 6.051 6.051 0 0 0 6.5146 2.9001A5.9847 5.9847 0 0 0 13.2599 24a6.0557 6.0557 0 0 0 5.7718-4.2058 5.9894 5.9894 0 0 0 3.9977-2.9001 6.0557 6.0557 0 0 0-.7475-7.0729zm-9.022 12.6081a4.4755 4.4755 0 0 1-2.8764-1.0408l.1419-.0804 4.7783-2.7582a.7948.7948 0 0 0 .3927-.6813v-6.7369l2.02 1.1686a.071.071 0 0 1 .038.052v5.5826a4.504 4.504 0 0 1-4.4945 4.4944zm-9.6607-4.1254a4.4708 4.4708 0 0 1-.5346-3.0137l.142.0852 4.783 2.7582a.7712.7712 0 0 0 .7806 0l5.8428-3.3685v2.3324a.0804.0804 0 0 1-.0332.0615L9.74 19.9502a4.4992 4.4992 0 0 1-6.1408-1.6464zM2.3408 7.8956a4.485 4.485 0 0 1 2.3655-1.9728V11.6a.7664.7664 0 0 0 .3879.6765l5.8144 3.3543-2.0201 1.1685a.0757.0757 0 0 1-.071 0l-4.8303-2.7865A4.504 4.504 0 0 1 2.3408 7.872zm16.5963 3.8558L13.1038 8.364 15.1192 7.2a.0757.0757 0 0 1 .071 0l4.8303 2.7913a4.4944 4.4944 0 0 1-.6765 8.1042v-5.6772a.79.79 0 0 0-.407-.667zm2.0107-3.0231l-.142-.0852-4.7735-2.7818a.7759.7759 0 0 0-.7854 0L9.409 9.2297V6.8974a.0662.0662 0 0 1 .0284-.0615l4.8303-2.7866a4.4992 4.4992 0 0 1 6.6802 4.66zM8.3065 12.863l-2.02-1.1638a.0804.0804 0 0 1-.038-.0567V6.0742a4.4992 4.4992 0 0 1 7.3757-3.4537l-.142.0805L8.704 5.459a.7948.7948 0 0 0-.3927.6813zm1.0976-2.3654l2.602-1.4998 2.6069 1.4998v2.9994l-2.5974 1.4997-2.6067-1.4997Z"
    />,
  ],
});

export const SlackIcon = createIcon({
  displayName: "Slack",
  viewBox: "0 0 270 270",
  path: [
    <path
      key="0"
      d="M99.4,151.2c0,7.1-5.8,12.9-12.9,12.9c-7.1,0-12.9-5.8-12.9-12.9c0-7.1,5.8-12.9,12.9-12.9h12.9V151.2z"
      fill="#E01E5A"
    />,
    <path
      key="1"
      d="M105.9,151.2c0-7.1,5.8-12.9,12.9-12.9s12.9,5.8,12.9,12.9v32.3c0,7.1-5.8,12.9-12.9,12.9s-12.9-5.8-12.9-12.9V151.2z"
      fill="#E01E5A"
    />,
    <path
      key="2"
      d="M118.8,99.4c-7.1,0-12.9-5.8-12.9-12.9c0-7.1,5.8-12.9,12.9-12.9s12.9,5.8,12.9,12.9v12.9H118.8z"
      fill="#36C5F0"
    />,
    <path
      key="3"
      d="M118.8,105.9c7.1,0,12.9,5.8,12.9,12.9s-5.8,12.9-12.9,12.9H86.5c-7.1,0-12.9-5.8-12.9-12.9s5.8-12.9,12.9-12.9H118.8z"
      fill="#36C5F0"
    />,
    <path
      key="4"
      d="M170.6,118.8c0-7.1,5.8-12.9,12.9-12.9c7.1,0,12.9,5.8,12.9,12.9s-5.8,12.9-12.9,12.9h-12.9V118.8z"
      fill="#2EB67D"
    />,
    <path
      key="5"
      d="M164.1,118.8c0,7.1-5.8,12.9-12.9,12.9c-7.1,0-12.9-5.8-12.9-12.9V86.5c0-7.1,5.8-12.9,12.9-12.9c7.1,0,12.9,5.8,12.9,12.9V118.8z"
      fill="#2EB67D"
    />,
    <path
      key="6"
      d="M151.2,170.6c7.1,0,12.9,5.8,12.9,12.9c0,7.1-5.8,12.9-12.9,12.9c-7.1,0-12.9-5.8-12.9-12.9v-12.9H151.2z"
      fill="#ECB22E"
    />,
    <path
      key="7"
      d="M151.2,164.1c-7.1,0-12.9-5.8-12.9-12.9c0-7.1,5.8-12.9,12.9-12.9h32.3c7.1,0,12.9,5.8,12.9,12.9c0,7.1-5.8,12.9-12.9,12.9H151.2z"
      fill="#ECB22E"
    />,
  ],
});

export const VercelIcon = createIcon({
  displayName: "Vercel",
  viewBox: "0 0 76 65",
  path: [<path key="1" d="M37.5274 0L75.0548 65H0L37.5274 0Z" fill="#000000" />],
});

export const DatadogIcon = createIcon({
  displayName: "Datadog",
  viewBox: "0 0 76 65",
  path: [
    <svg
      key="1"
      enableBackground="new 0 0 800.5 800.5"
      viewBox="0 0 800.5 800.5"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipRule="evenodd" fill="#632ca6" fillRule="evenodd">
        <path d="m52.12 799.39h-51.87v-119.41h51.87c37.37 0 56.08 18.82 56.08 56.45 0 41.95-18.71 62.96-56.08 62.96m-29.69-19.22h26.34c24.83 0 37.23-14.58 37.23-43.76 0-24.84-12.4-37.26-37.23-37.26h-26.34zm109.01 19.22h-22.77l50.79-119.41h23.84l51.9 119.41h-23.86l-15.06-32.57h-38.33l7.62-19.19h24.86l-19.59-44.86zm91.22-119.41h90.8v19.2h-34.31v100.21h-22.17v-100.21h-34.33zm102.2 119.41h-22.77l50.8-119.41h23.84l51.89 119.41h-23.86l-15.06-32.57h-38.33l7.6-19.19h24.86l-19.59-44.86zm170.34 0h-51.87v-119.41h51.87c37.39 0 56.08 18.82 56.08 56.45 0 41.95-18.69 62.96-56.08 62.96m-29.7-19.22h26.36c24.81 0 37.24-14.58 37.24-43.76 0-24.84-12.43-37.26-37.24-37.26h-26.36zm100.79-40.32c0-40.49 20.05-60.73 60.1-60.73 39.44 0 59.15 20.24 59.15 60.73 0 40.25-19.71 60.4-59.15 60.4-38.28-.01-58.29-20.15-60.1-60.4m60.1 41.15c24.09 0 36.14-13.88 36.14-41.66 0-27.35-12.05-41.04-36.14-41.04-24.72 0-37.07 13.69-37.07 41.04.01 27.78 12.36 41.66 37.07 41.66m151.68-29.93v27.95c-5.12 1.34-9.71 1.99-13.72 1.99-27.13 0-40.67-14.33-40.67-43 0-26.47 14.38-39.7 43.09-39.7 12 0 23.15 2.23 33.47 6.69v-20.05c-10.31-3.89-22.02-5.85-35.14-5.85-42.95 0-64.44 19.62-64.44 58.9 0 41.46 21.12 62.23 63.35 62.23 14.53 0 26.6-2.12 36.24-6.36v-62.47h-35.81l-7.49 19.65h21.12z" />
        <path d="m600.37 450.73-52.78-34.82-44.03 73.55-51.21-14.97-45.09 68.82 2.31 21.66 245.17-45.18-14.24-153.19zm-228.63-66.04 39.34-5.41c6.36 2.86 10.79 3.95 18.42 5.89 11.89 3.09 25.64 6.06 46.01-4.2 4.74-2.35 14.62-11.38 18.61-16.53l161.16-29.23 16.44 198.98-276.11 49.76zm299.36-71.7-15.91 3.03-30.56-315.76-520.75 60.38 64.16 520.62 60.96-8.85c-4.87-6.95-12.45-15.36-25.39-26.12-17.95-14.91-11.61-40.25-1.01-56.25 14.01-27.03 86.2-61.38 82.11-104.58-1.47-15.71-3.96-36.15-18.55-50.17-.55 5.82.44 11.41.44 11.41s-5.99-7.64-8.97-18.05c-2.96-4-5.29-5.27-8.44-10.61-2.25 6.17-1.95 13.33-1.95 13.33s-4.9-11.57-5.69-21.34c-2.9 4.37-3.63 12.67-3.63 12.67s-6.36-18.24-4.91-28.07c-2.9-8.55-11.51-25.52-9.08-64.08 15.89 11.13 50.88 8.49 64.51-11.6 4.52-6.66 7.63-24.82-2.26-60.62-6.35-22.95-22.07-57.13-28.2-70.1l-.73.53c3.23 10.45 9.89 32.34 12.45 42.97 7.74 32.2 9.81 43.42 6.18 58.27-3.09 12.91-10.5 21.35-29.28 30.79-18.78 9.47-43.71-13.58-45.28-14.85-18.25-14.54-32.37-38.25-33.94-49.78-1.64-12.61 7.27-20.18 11.76-30.49-6.43 1.83-13.59 5.1-13.59 5.1s8.55-8.85 19.09-16.5c4.37-2.89 6.93-4.73 11.53-8.55-6.66-.11-12.07.08-12.07.08s11.11-6 22.62-10.37c-8.42-.37-16.49-.06-16.49-.06s24.79-11.09 44.36-19.22c13.46-5.52 26.61-3.89 34 6.8 9.7 14 19.89 21.6 41.48 26.31 13.26-5.88 17.28-8.89 33.94-13.44 14.66-16.13 26.17-18.21 26.17-18.21s-5.71 5.24-7.24 13.47c8.31-6.55 17.42-12.02 17.42-12.02s-3.53 4.35-6.82 11.27l.76 1.14c9.7-5.82 21.1-10.4 21.1-10.4s-3.26 4.12-7.08 9.45c7.32-.06 22.15.31 27.91.96 33.99.75 41.04-36.29 54.08-40.94 16.33-5.83 23.63-9.36 51.46 17.98 23.87 23.48 42.53 65.48 33.26 74.89-7.77 7.81-23.09-3.05-40.07-24.21-8.97-11.21-15.76-24.46-18.94-41.3-2.68-14.21-13.12-22.45-13.12-22.45s6.05 13.5 6.05 25.39c0 6.5.81 30.79 11.23 44.43-1.03 1.99-1.51 9.86-2.65 11.37-12.12-14.65-38.15-25.13-42.4-28.22 14.37 11.77 47.39 38.81 60.07 64.74 12 24.51 4.93 46.98 11 52.79 1.73 1.66 25.8 31.66 30.43 46.73 8.08 26.26.48 53.87-10.09 70.99l-29.53 4.6c-4.32-1.2-7.23-1.8-11.1-4.04 2.14-3.78 6.38-13.2 6.42-15.15l-1.67-2.92c-9.19 13.02-24.58 25.66-37.37 32.92-16.74 9.49-36.03 8.02-48.59 4.14-35.64-10.99-69.35-35.08-77.48-41.41 0 0-.25 5.05 1.28 6.19 8.98 10.14 29.57 28.47 49.48 41.26l-42.43 4.67 20.06 156.17c-8.89 1.27-10.28 1.9-20.01 3.28-8.58-30.31-24.99-50.1-42.93-61.63-15.82-10.17-37.64-12.46-58.52-8.32l-1.34 1.56c14.52-1.51 31.66.59 49.27 11.74 17.28 10.93 31.21 39.16 36.34 56.15 6.57 21.72 11.11 44.96-6.57 69.59-12.57 17.51-49.27 27.18-78.93 6.25 7.92 12.74 18.62 23.15 33.04 25.11 21.4 2.91 41.71-.81 55.69-15.16 11.93-12.27 18.27-37.93 16.6-64.95l18.89-2.74 6.82 48.5 312.65-37.65zm-190.22-131.71c-.87 1.99-2.25 3.3-.19 9.78l.12.37.33.84.86 1.94c3.71 7.59 7.78 14.74 14.6 18.4 1.76-.3 3.59-.5 5.48-.59 6.4-.28 10.44.73 12.99 2.11.23-1.28.28-3.14.14-5.89-.5-9.61 1.9-25.95-16.57-34.55-6.97-3.23-16.75-2.24-20.01 1.8.59.08 1.12.2 1.54.34 4.94 1.71 1.6 3.41.71 5.45m51.78 89.66c-2.42-1.34-13.74-.81-21.7.14-15.16 1.79-31.53 7.04-35.11 9.84-6.52 5.04-3.56 13.82 1.26 17.43 13.51 10.09 25.35 16.86 37.84 15.21 7.67-1.01 14.44-13.16 19.23-24.18 3.28-7.59 3.28-15.78-1.52-18.44m-134.21-77.77c4.27-4.06-21.29-9.39-41.13 4.14-14.63 9.98-15.1 31.38-1.09 43.51 1.4 1.2 2.56 2.05 3.63 2.75 4.09-1.93 8.75-3.87 14.12-5.61 9.06-2.94 16.6-4.46 22.79-5.27 2.96-3.31 6.41-9.14 5.55-19.7-1.18-14.33-12.02-12.06-3.87-19.82" />
      </g>
    </svg>,
  ],
});

export const PlanetScaleIcon = createIcon({
  displayName: "PlanetScale",
  viewBox: "0 0 256 256",
  path: [
    <path
      key={0}
      d="M256 128.044c-.024 70.657-57.299 127.932-127.956 127.956ZM128 0c51.977 0 96.719 30.98 116.765 75.483L75.483 244.765a127.791 127.791 0 0 1-20.636-11.715L159.897 128H128l-90.51 90.51C14.327 195.345 0 163.345 0 128C0 57.308 57.308 0 128 0"
    />,
  ],
});
export const NeonIcon = createIcon({
  displayName: "Neon",
  viewBox: "0 0 36 36",
  path: [
    <path
      key={0}
      d="M6 4.2A2.21 2.21 0 0 1 8.2 2h5.87a2.21 2.21 0 0 1 1.76.88l3.72 4.97V2.16A.16.16 0 0 1 19.71 2H27.8A2.21 2.21 0 0 1 30 4.2v17.6A2.21 2.21 0 0 1 27.8 24h-5.87a2.21 2.21 0 0 1-1.76-.88L16.45 18.15V23.84a.16.16 0 0 1-.16.16H8.2A2.21 2.21 0 0 1 6 21.8V4.2z"
      fill="#00E599"
    />,
  ],
});
export const SupabaseIcon = createIcon({
  displayName: "Supabase",
  viewBox: "0 0 109 113",
  path: [
    <path
      key={0}
      d="M63.708 110.284c-2.86 3.601-8.658 1.628-8.727-2.97l-1.007-67.251h45.22c8.19 0 12.758 9.46 7.665 15.874l-35.15 44.347z"
      fill="url(#supabase-a)"
    />,
    <path
      key={1}
      d="M63.708 110.284c-2.86 3.601-8.658 1.628-8.727-2.97l-1.007-67.251h45.22c8.19 0 12.758 9.46 7.665 15.874l-35.15 44.347z"
      fill="url(#supabase-b)"
      fillOpacity={0.2}
    />,
    <path
      key={2}
      d="M45.317 2.071c2.86-3.601 8.657-1.628 8.726 2.97l.442 67.251H9.83c-8.19 0-12.759-9.46-7.665-15.875L45.317 2.071z"
      fill="#3ECF8E"
    />,
    <defs key={3}>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="supabase-a"
        x1="53.974"
        x2="94.163"
        y1="54.974"
        y2="71.829"
      >
        <stop stopColor="#249361" />
        <stop offset={1} stopColor="#3ECF8E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="supabase-b"
        x1="36.156"
        x2="54.484"
        y1="30.578"
        y2="65.081"
      >
        <stop />
        <stop offset={1} stopOpacity={0} />
      </linearGradient>
    </defs>,
  ],
});
export const NvidiaIcon = createIcon({
  displayName: "Nvidia",
  viewBox: "0 0 95 95",
  path: [
    <svg key="1" viewBox="0 0 164 30">
      <defs>
        <path d="M157.725 29.99H.01V.048h157.715z" id="a" />
      </defs>
      <g fill="none" fill-rule="evenodd">
        <path
          d="M160.352 24.069v-.449h.288c.157 0 .371.012.371.204 0 .208-.11.245-.296.245h-.363m0 .315h.192l.447.784h.49l-.494-.816c.255-.019.465-.14.465-.484 0-.427-.295-.565-.793-.565h-.721v1.865h.414v-.784m2.098-.146c0-1.095-.851-1.73-1.8-1.73-.955 0-1.805.635-1.805 1.73s.85 1.733 1.805 1.733c.948 0 1.8-.638 1.8-1.733m-.52 0c0 .798-.587 1.334-1.28 1.334v-.006c-.713.006-1.289-.53-1.289-1.328 0-.797.577-1.331 1.289-1.331.694 0 1.28.534 1.28 1.331"
          fill="#1A1919"
        />
        <path
          d="m96.374 5.707.002 19.66h5.552V5.707h-5.554zm-43.677-.026v19.686H58.3V10.086l4.37.014c1.437 0 2.43.345 3.123 1.084.879.936 1.237 2.444 1.237 5.205v8.978h5.427V14.49c0-7.763-4.948-8.81-9.789-8.81h-9.97zm52.617.027v19.659h9.006c4.798 0 6.364-.798 8.057-2.587 1.198-1.256 1.971-4.014 1.971-7.027 0-2.763-.655-5.228-1.797-6.763-2.057-2.745-5.02-3.282-9.445-3.282h-7.792zm5.508 4.28h2.387c3.463 0 5.703 1.556 5.703 5.591 0 4.037-2.24 5.592-5.703 5.592h-2.387V9.989zm-22.453-4.28-4.634 15.58-4.44-15.579-5.993-.001 6.34 19.659h8.003l6.391-19.659H88.37zm38.563 19.659h5.553V5.709l-5.555-.001.002 19.659zm15.564-19.652-7.753 19.645h5.475l1.227-3.472h9.175l1.161 3.472h5.944l-7.812-19.646-7.417.001zM146.1 9.3l3.364 9.204h-6.833l3.47-9.204z"
          fill="#000"
        />
        <path
          d="M16.889 8.985V6.28c.262-.02.528-.033.798-.042 7.4-.232 12.255 6.359 12.255 6.359s-5.244 7.282-10.866 7.282a6.82 6.82 0 0 1-2.187-.35v-8.204c2.88.348 3.46 1.62 5.192 4.508l3.852-3.248s-2.812-3.688-7.552-3.688c-.515 0-1.008.036-1.492.088zm0-8.938V4.09c.265-.021.531-.038.798-.048 10.29-.346 16.995 8.44 16.995 8.44s-7.7 9.364-15.723 9.364c-.735 0-1.424-.068-2.07-.183v2.498c.553.07 1.126.112 1.724.112 7.465 0 12.864-3.812 18.092-8.325.867.694 4.416 2.383 5.145 3.123-4.971 4.16-16.555 7.515-23.123 7.515a18.89 18.89 0 0 1-1.838-.096V30h28.375V.047H16.89zm0 19.482v2.133c-6.905-1.23-8.822-8.408-8.822-8.408s3.316-3.674 8.822-4.269v2.34l-.011-.001c-2.89-.347-5.147 2.353-5.147 2.353s1.265 4.544 5.158 5.852zM4.625 12.943s4.092-6.04 12.264-6.663V4.088C7.838 4.815 0 12.48 0 12.48s4.439 12.833 16.889 14.008V24.16C7.753 23.011 4.625 12.943 4.625 12.943z"
          fill="#76B900"
        />
      </g>
    </svg>,
  ],
});
export const HuggingFaceIcon = createIcon({
  displayName: "HuggingFace",
  viewBox: "0 0 95 95",
  path: [
    <svg key="1" fill="none" height="88" width="95" xmlns="http://www.w3.org/2000/svg">
      <path d="M47.21 76.5a34.75 34.75 0 1 0 0-69.5 34.75 34.75 0 0 0 0 69.5Z" fill="#FFD21E" />
      <path
        d="M81.96 41.75a34.75 34.75 0 1 0-69.5 0 34.75 34.75 0 0 0 69.5 0Zm-73.5 0a38.75 38.75 0 1 1 77.5 0 38.75 38.75 0 0 1-77.5 0Z"
        fill="#FF9D0B"
      />
      <path
        d="M58.5 32.3c1.28.44 1.78 3.06 3.07 2.38a5 5 0 1 0-6.76-2.07c.61 1.15 2.55-.72 3.7-.32ZM34.95 32.3c-1.28.44-1.79 3.06-3.07 2.38a5 5 0 1 1 6.76-2.07c-.61 1.15-2.56-.72-3.7-.32Z"
        fill="#3A3B45"
      />
      <path
        d="M46.96 56.29c9.83 0 13-8.76 13-13.26 0-2.34-1.57-1.6-4.09-.36-2.33 1.15-5.46 2.74-8.9 2.74-7.19 0-13-6.88-13-2.38s3.16 13.26 13 13.26Z"
        fill="#FF323D"
      />
      <path
        clip-rule="evenodd"
        d="M39.43 54a8.7 8.7 0 0 1 5.3-4.49c.4-.12.81.57 1.24 1.28.4.68.82 1.37 1.24 1.37.45 0 .9-.68 1.33-1.35.45-.7.89-1.38 1.32-1.25a8.61 8.61 0 0 1 5 4.17c3.73-2.94 5.1-7.74 5.1-10.7 0-2.34-1.57-1.6-4.09-.36l-.14.07c-2.31 1.15-5.39 2.67-8.77 2.67s-6.45-1.52-8.77-2.67c-2.6-1.29-4.23-2.1-4.23.29 0 3.05 1.46 8.06 5.47 10.97Z"
        fill="#3A3B45"
        fill-rule="evenodd"
      />
      <path
        d="M70.71 37a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5ZM24.21 37a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5ZM17.52 48c-1.62 0-3.06.66-4.07 1.87a5.97 5.97 0 0 0-1.33 3.76 7.1 7.1 0 0 0-1.94-.3c-1.55 0-2.95.59-3.94 1.66a5.8 5.8 0 0 0-.8 7 5.3 5.3 0 0 0-1.79 2.82c-.24.9-.48 2.8.8 4.74a5.22 5.22 0 0 0-.37 5.02c1.02 2.32 3.57 4.14 8.52 6.1 3.07 1.22 5.89 2 5.91 2.01a44.33 44.33 0 0 0 10.93 1.6c5.86 0 10.05-1.8 12.46-5.34 3.88-5.69 3.33-10.9-1.7-15.92-2.77-2.78-4.62-6.87-5-7.77-.78-2.66-2.84-5.62-6.25-5.62a5.7 5.7 0 0 0-4.6 2.46c-1-1.26-1.98-2.25-2.86-2.82A7.4 7.4 0 0 0 17.52 48Zm0 4c.51 0 1.14.22 1.82.65 2.14 1.36 6.25 8.43 7.76 11.18.5.92 1.37 1.31 2.14 1.31 1.55 0 2.75-1.53.15-3.48-3.92-2.93-2.55-7.72-.68-8.01.08-.02.17-.02.24-.02 1.7 0 2.45 2.93 2.45 2.93s2.2 5.52 5.98 9.3c3.77 3.77 3.97 6.8 1.22 10.83-1.88 2.75-5.47 3.58-9.16 3.58-3.81 0-7.73-.9-9.92-1.46-.11-.03-13.45-3.8-11.76-7 .28-.54.75-.76 1.34-.76 2.38 0 6.7 3.54 8.57 3.54.41 0 .7-.17.83-.6.79-2.85-12.06-4.05-10.98-8.17.2-.73.71-1.02 1.44-1.02 3.14 0 10.2 5.53 11.68 5.53.11 0 .2-.03.24-.1.74-1.2.33-2.04-4.9-5.2-5.21-3.16-8.88-5.06-6.8-7.33.24-.26.58-.38 1-.38 3.17 0 10.66 6.82 10.66 6.82s2.02 2.1 3.25 2.1c.28 0 .52-.1.68-.38.86-1.46-8.06-8.22-8.56-11.01-.34-1.9.24-2.85 1.31-2.85Z"
        fill="#FF9D0B"
      />
      <path
        d="M38.6 76.69c2.75-4.04 2.55-7.07-1.22-10.84-3.78-3.77-5.98-9.3-5.98-9.3s-.82-3.2-2.69-2.9c-1.87.3-3.24 5.08.68 8.01 3.91 2.93-.78 4.92-2.29 2.17-1.5-2.75-5.62-9.82-7.76-11.18-2.13-1.35-3.63-.6-3.13 2.2.5 2.79 9.43 9.55 8.56 11-.87 1.47-3.93-1.71-3.93-1.71s-9.57-8.71-11.66-6.44c-2.08 2.27 1.59 4.17 6.8 7.33 5.23 3.16 5.64 4 4.9 5.2-.75 1.2-12.28-8.53-13.36-4.4-1.08 4.11 11.77 5.3 10.98 8.15-.8 2.85-9.06-5.38-10.74-2.18-1.7 3.21 11.65 6.98 11.76 7.01 4.3 1.12 15.25 3.49 19.08-2.12Z"
        fill="#FFD21E"
      />
      <path
        d="M77.4 48c1.62 0 3.07.66 4.07 1.87a5.97 5.97 0 0 1 1.33 3.76 7.1 7.1 0 0 1 1.95-.3c1.55 0 2.95.59 3.94 1.66a5.8 5.8 0 0 1 .8 7 5.3 5.3 0 0 1 1.78 2.82c.24.9.48 2.8-.8 4.74a5.22 5.22 0 0 1 .37 5.02c-1.02 2.32-3.57 4.14-8.51 6.1-3.08 1.22-5.9 2-5.92 2.01a44.33 44.33 0 0 1-10.93 1.6c-5.86 0-10.05-1.8-12.46-5.34-3.88-5.69-3.33-10.9 1.7-15.92 2.78-2.78 4.63-6.87 5.01-7.77.78-2.66 2.83-5.62 6.24-5.62a5.7 5.7 0 0 1 4.6 2.46c1-1.26 1.98-2.25 2.87-2.82A7.4 7.4 0 0 1 77.4 48Zm0 4c-.51 0-1.13.22-1.82.65-2.13 1.36-6.25 8.43-7.76 11.18a2.43 2.43 0 0 1-2.14 1.31c-1.54 0-2.75-1.53-.14-3.48 3.91-2.93 2.54-7.72.67-8.01a1.54 1.54 0 0 0-.24-.02c-1.7 0-2.45 2.93-2.45 2.93s-2.2 5.52-5.97 9.3c-3.78 3.77-3.98 6.8-1.22 10.83 1.87 2.75 5.47 3.58 9.15 3.58 3.82 0 7.73-.9 9.93-1.46.1-.03 13.45-3.8 11.76-7-.29-.54-.75-.76-1.34-.76-2.38 0-6.71 3.54-8.57 3.54-.42 0-.71-.17-.83-.6-.8-2.85 12.05-4.05 10.97-8.17-.19-.73-.7-1.02-1.44-1.02-3.14 0-10.2 5.53-11.68 5.53-.1 0-.19-.03-.23-.1-.74-1.2-.34-2.04 4.88-5.2 5.23-3.16 8.9-5.06 6.8-7.33-.23-.26-.57-.38-.98-.38-3.18 0-10.67 6.82-10.67 6.82s-2.02 2.1-3.24 2.1a.74.74 0 0 1-.68-.38c-.87-1.46 8.05-8.22 8.55-11.01.34-1.9-.24-2.85-1.31-2.85Z"
        fill="#FF9D0B"
      />
      <path
        d="M56.33 76.69c-2.75-4.04-2.56-7.07 1.22-10.84 3.77-3.77 5.97-9.3 5.97-9.3s.82-3.2 2.7-2.9c1.86.3 3.23 5.08-.68 8.01-3.92 2.93.78 4.92 2.28 2.17 1.51-2.75 5.63-9.82 7.76-11.18 2.13-1.35 3.64-.6 3.13 2.2-.5 2.79-9.42 9.55-8.55 11 .86 1.47 3.92-1.71 3.92-1.71s9.58-8.71 11.66-6.44c2.08 2.27-1.58 4.17-6.8 7.33-5.23 3.16-5.63 4-4.9 5.2.75 1.2 12.28-8.53 13.36-4.4 1.08 4.11-11.76 5.3-10.97 8.15.8 2.85 9.05-5.38 10.74-2.18 1.69 3.21-11.65 6.98-11.76 7.01-4.31 1.12-15.26 3.49-19.08-2.12Z"
        fill="#FFD21E"
      />
    </svg>,
  ],
});

export const WandbIcon = createIcon({
  displayName: "WandB",
  viewBox: "0 0 100 100",
  path: [
    <svg
      key="1"
      fill="none"
      height="100"
      viewBox="0 0 100 100"
      width="100"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M-5.91278e-05 32.3C-5.91278e-05 38.0084 4.62746 42.6359 10.3358 42.6359C16.0441 42.6359 20.6716 38.0084 20.6716 32.3C20.6716 26.5917 16.0441 21.9642 10.3358 21.9642C4.62746 21.9642 -5.91278e-05 26.5917 -5.91278e-05 32.3Z"
        fill="#FFCC33"
      />
      <path
        d="M-5.91278e-05 83.9792C-5.91278e-05 89.6875 4.62746 94.3151 10.3358 94.3151C16.0441 94.3151 20.6716 89.6875 20.6716 83.9792C20.6716 78.2709 16.0441 73.6434 10.3358 73.6434C4.62746 73.6434 -5.91278e-05 78.2709 -5.91278e-05 83.9792Z"
        fill="#FFCC33"
      />
      <path
        d="M3.87589 58.1402C3.87589 61.7079 6.76813 64.6002 10.3359 64.6002C13.9037 64.6002 16.7959 61.7079 16.7959 58.1402C16.7959 54.5724 13.9037 51.6802 10.3359 51.6802C6.76813 51.6802 3.87589 54.5724 3.87589 58.1402Z"
        fill="#FFCC33"
      />
      <path
        d="M3.87589 6.46001C3.87589 10.0278 6.76813 12.92 10.3359 12.92C13.9037 12.92 16.7959 10.0278 16.7959 6.46001C16.7959 2.89224 13.9037 0 10.3359 0C6.76813 0 3.87589 2.89224 3.87589 6.46001Z"
        fill="#FFCC33"
      />
      <path
        d="M39.664 67.7001C39.664 73.4084 44.2915 78.0359 49.9998 78.0359C55.7082 78.0359 60.3357 73.4084 60.3357 67.7001C60.3357 61.9918 55.7082 57.3643 49.9998 57.3643C44.2915 57.3643 39.664 61.9918 39.664 67.7001Z"
        fill="#FFCC33"
      />
      <path
        d="M43.5399 93.5402C43.5399 97.108 46.4322 100 50 100C53.5677 100 56.46 97.108 56.46 93.5402C56.46 89.9724 53.5677 87.0802 50 87.0802C46.4322 87.0802 43.5399 89.9724 43.5399 93.5402Z"
        fill="#FFCC33"
      />
      <path
        d="M43.5399 41.8609C43.5399 45.4286 46.4322 48.3209 50 48.3209C53.5677 48.3209 56.46 45.4286 56.46 41.8609C56.46 38.2931 53.5677 35.4008 50 35.4008C46.4322 35.4008 43.5399 38.2931 43.5399 41.8609Z"
        fill="#FFCC33"
      />
      <path
        d="M43.5399 16.0208C43.5399 19.5886 46.4322 22.4808 50 22.4808C53.5677 22.4808 56.46 19.5886 56.46 16.0208C56.46 12.453 53.5677 9.56079 50 9.56079C46.4322 9.56079 43.5399 12.453 43.5399 16.0208Z"
        fill="#FFCC33"
      />
      <path
        d="M79.3283 32.3C79.3283 38.0084 83.9558 42.6359 89.6642 42.6359C95.3725 42.6359 100 38.0084 100 32.3C100 26.5917 95.3725 21.9642 89.6642 21.9642C83.9558 21.9642 79.3283 26.5917 79.3283 32.3Z"
        fill="#FFCC33"
      />
      <path
        d="M83.2043 6.46001C83.2043 10.0278 86.0965 12.92 89.6643 12.92C93.232 12.92 96.1243 10.0278 96.1243 6.46001C96.1243 2.89224 93.232 0 89.6643 0C86.0965 0 83.2043 2.89224 83.2043 6.46001Z"
        fill="#FFCC33"
      />
      <path
        d="M83.2043 58.1402C83.2043 61.7079 86.0965 64.6002 89.6643 64.6002C93.232 64.6002 96.1243 61.7079 96.1243 58.1402C96.1243 54.5724 93.232 51.6802 89.6643 51.6802C86.0965 51.6802 83.2043 54.5724 83.2043 58.1402Z"
        fill="#FFCC33"
      />
      <path
        d="M83.2043 83.9793C83.2043 87.5471 86.0965 90.4393 89.6643 90.4393C93.232 90.4393 96.1243 87.5471 96.1243 83.9793C96.1243 80.4115 93.232 77.5193 89.6643 77.5193C86.0965 77.5193 83.2043 80.4115 83.2043 83.9793Z"
        fill="#FFCC33"
      />
    </svg>,
  ],
});

export const LangfuseIcon = createIcon({
  displayName: "Langfuse",
  viewBox: "0 0 512 512",
  path: [
    <path
      key="0"
      d="M254.75 302.25L285.25 326.75C285.25 326.75 308.587 309.418 325.75 306.875C343.75 304.208 362.954 314.244 380.75 326.208C407.629 344.279 430.25 367.208 430.25 367.208L456.75 341.208C456.75 341.208 383.686 262.047 325.75 269.208C287.75 273.905 254.75 302.25 254.75 302.25Z"
      fill="#FF5D5F"
    />,
    <path
      key="1"
      d="M80.25 151.286L55.25 178.786C55.25 178.786 124.902 243.786 179.75 243.786C204.75 243.786 239.419 224.201 269.25 198.757C286.25 184.257 305.25 167.786 324.25 167.786C337.021 167.786 353.866 174.551 369.75 192.316C369.75 192.316 380.003 186.168 386.25 181.75C391.74 177.868 399.896 171.25 399.896 171.25C377.047 146.864 343.998 129.038 324.25 130.786C292.25 130.79 269.25 150.711 240.75 173.75C212.25 196.789 200.25 206.286 179.75 206.286C145.25 206.286 80.25 151.286 80.25 151.286Z"
      fill="#4E9CFF"
    />,
    <path
      key="2"
      d="M80.25 360.75L55.25 333.25C55.25 333.25 124.902 268.25 179.75 268.25C204.75 268.25 239.419 287.835 269.25 313.279C286.25 327.779 305.25 344.25 324.25 344.25C337.083 344.25 353.799 337.207 369.75 319.25C369.75 319.25 379.339 325.161 385.25 329.25C391.328 333.455 400.25 340.407 400.25 340.407C377.39 364.987 344.1 383.007 324.25 381.25C292.25 381.246 273.25 364.289 244.75 341.25C216.25 318.211 200.25 305.75 179.75 305.75C145.25 305.75 80.25 360.75 80.25 360.75Z"
      fill="#4E9CFF"
    />,
    <path
      key="3"
      d="M406.25 213.25C399.745 217.746 389.25 224.25 389.25 224.25C389.25 224.25 395.25 237.25 395.25 254.75C395.25 272.25 389.75 287.25 389.75 287.25C389.75 287.25 399.172 293.135 405.25 297.25C411.564 301.525 421.25 308.75 421.25 308.75C421.25 308.75 432.75 284.75 432.75 254.75C432.75 224.75 421.25 202.25 421.25 202.25C421.25 202.25 412.226 209.12 406.25 213.25Z"
      fill="#4E9CFF"
    />,
    <path
      key="4"
      d="M256.25 209.25L285.25 185.25C285.25 185.25 308.587 202.04 325.75 204.583C343.75 207.25 362.954 197.214 380.75 185.25C407.629 167.179 430.25 144.25 430.25 144.25L456.75 170.25C456.75 170.25 383.686 249.411 325.75 242.25C287.75 237.553 256.25 209.25 256.25 209.25Z"
      fill="#FF5D5F"
    />,
    <path
      key="5"
      d="M186.255 130.25C223.755 130.25 255.25 162.25 255.25 162.25C255.25 162.25 246.487 169.155 240.75 173.75C234.775 178.536 225.25 186.25 225.25 186.25C225.25 186.25 208.755 168.75 186.255 168.75C177.028 168.75 165.039 174.292 152.255 185.25C142.391 193.705 132.129 204.216 125.255 217.25C119.31 228.52 116.068 241.802 115.755 255.75C115.361 273.269 121.571 291.634 131.755 306.25C138.58 316.046 146.726 323.418 155.255 329.75C166.323 337.968 177.865 343.75 186.255 343.75C195.217 343.75 203.274 340.635 209.255 337.75C218.755 332.25 226.25 325.75 226.25 325.75L255.75 350.25C255.75 350.25 243.75 362.25 227.255 371.25C216.595 376.507 202.895 381.75 186.255 381.75C169.626 381.75 150.315 372.915 132.255 359.25C120.579 350.416 109.135 339.948 100.255 327.25C85.7005 306.438 78.2004 281.118 78.2502 255.75C78.3008 230.065 86.5823 204.625 101.255 183.75C124.255 153.75 158.273 130.25 186.255 130.25Z"
      fill="#FF5D5F"
    />,
  ],
});

const mapCloudProvidersToIcons = {
  [CloudProviderEnum.Aws]: AwsIcon,
  [CloudProviderEnum.AwsGovCloud]: AwsIcon,
  [CloudProviderEnum.Azure]: AzureIcon,
  [CloudProviderEnum.Gcp]: GcpIcon,
};

export function CloudProviderIcon({ type, ...props }: { type?: CloudProviderEnum } & IconProps) {
  return <Icon as={type ? mapCloudProvidersToIcons[type] : undefined} h={5} w={5} {...props} />;
}

const mapPoolTypesToIcons = {
  rdspool: RdsIcon,
  cloudsqlpool: CloudSqlIcon,
  aurorapool: AuroraIcon,
  planetscalepool: PlanetScaleIcon,
  neonpool: NeonIcon,
  supabasepool: SupabaseIcon,
};
export function PoolTypeIcon({ type, ...props }: { type?: string } & IconProps) {
  const icon = mapPoolTypesToIcons[type?.toLowerCase() as keyof typeof mapPoolTypesToIcons];
  return <Icon as={icon} h={5} w={5} {...props} />;
}

const mapDatabaseTypesToIcons = {
  postgres: PostgresIcon,
  postgresql: PostgresIcon,
  mysql: MysqlIcon,
  mariadb: MariadbIcon,
  "aurora-postgresql": PostgresIcon,
  "aurora-mysql": MysqlIcon,
};
export function DatabaseTypeIcon({ type, ...props }: { type?: string } & IconProps) {
  const icon = mapDatabaseTypesToIcons[type?.toLowerCase() as keyof typeof mapDatabaseTypesToIcons];
  return <Icon as={icon} h={5} w={5} {...props} />;
}

const mapSourceControlProvidersToIcons = {
  bitbucket: BitbucketIcon,
  github: GitHubIcon,
  gitlab: GitLabIcon,
};
export function SourceControlProviderIcon({ provider, ...props }: { provider?: string | null } & IconProps) {
  const icon =
    mapSourceControlProvidersToIcons[
      provider?.toLowerCase() as keyof typeof mapSourceControlProvidersToIcons
    ];
  return <Icon as={icon} h={5} w={5} {...props} />;
}

const mapBrandsToIcons = {
  amazon: AwsIcon,
  bitbucket: BitbucketIcon,
  docker: DockerIcon,
  github: GitHubIcon,
  gitlab: GitLabIcon,
  google: GoogleIcon,
  helm: HelmIcon,
  static: JsIcon,
  "workos-saml": WorkOSIcon,
  anthropic: AnthropicIcon,
  openai: OpenAiIcon,
  slack: SlackIcon,
  vercel: VercelIcon,
  datadog: DatadogIcon,
  planetscale: PlanetScaleIcon,
  neon: NeonIcon,
  supabase: SupabaseIcon,
  huggingface: HuggingFaceIcon,
  nvidia: NvidiaIcon,
  wandb: WandbIcon,
  langfuse: LangfuseIcon,
};

export function BrandedIcon({ brand, ...props }: { brand?: string } & IconProps) {
  const icon = mapBrandsToIcons[brand?.toLowerCase() as keyof typeof mapBrandsToIcons];
  return <Icon as={icon} {...props} />;
}
